//  via https://stop-words.googlecode.com/svn/trunk/stop-words/stop-words/stop-words-spanish.txt
module.exports = {
    stopwords: [
        'a',
        'algún',
        'alguna',
        'algunas',
        'alguno',
        'algunos',
        'ambos',
        'ampleamos',
        'ante',
        'antes',
        'aquel',
        'aquellas',
        'aquellos',
        'aqui',
        'arriba',
        'atras',
        'bajo',
        'bastante',
        'cada',
        'cierta',
        'ciertas',
        'cierto',
        'ciertos',
        'como',
        'con',
        'conseguimos',
        'conseguir',
        'consigo',
        'consigue',
        'consiguen',
        'consigues',
        'cual',
        'cuando',
        'de',
        'del',
        'dentro',
        'desde',
        'donde',
        'dos',
        'el',
        'ellas',
        'ellos',
        'empleais',
        'emplean',
        'emplear',
        'empleas',
        'empleo',
        'en',
        'encima',
        'entonces',
        'entre',
        'era',
        'eramos',
        'eran',
        'eras',
        'eres',
        'es',
        'esta',
        'estaba',
        'estado',
        'estais',
        'estamos',
        'estan',
        'estoy',
        'fin',
        'fue',
        'fueron',
        'fui',
        'fuimos',
        'gueno',
        'ha',
        'hace',
        'haceis',
        'hacemos',
        'hacen',
        'hacer',
        'haces',
        'hago',
        'incluso',
        'intenta',
        'intentais',
        'intentamos',
        'intentan',
        'intentar',
        'intentas',
        'intento',
        'ir',
        'la',
        'largo',
        'las',
        'lo',
        'los',
        'me',
        'mientras',
        'mi',
        'mio',
        'modo',
        'mucho',
        'muchos',
        'más',
        'mas',
        'muy',
        'nos',
        'nosotros',
        'otra',
        'otras',
        'otro',
        'otros',
        'para',
        'pero',
        'podeis',
        'podemos',
        'poder',
        'podria',
        'podriais',
        'podriamos',
        'podrian',
        'podrias',
        'por',
        'por favor',
        'por qué',
        'porque',
        'primero',
        'puede',
        'pueden',
        'puedo',
        'qué',
        'que',
        'quien',
        'sabe',
        'sabeis',
        'sabemos',
        'saben',
        'saber',
        'sabes',
        'se',
        'ser',
        'si',
        'siendo',
        'sin',
        'sobre',
        'sois',
        'solamente',
        'solo',
        'somos',
        'soy',
        'su',
        'sus',
        'también',
        'te',
        'teneis',
        'tenemos',
        'tener',
        'tengo',
        'tiempo',
        'tiene',
        'tienen',
        'todo',
        'trabaja',
        'trabajais',
        'trabajamos',
        'trabajan',
        'trabajar',
        'trabajas',
        'tras',
        'tuyo',
        'ultimo',
        'un',
        'una',
        'unas',
        'uno',
        'unos',
        'usa',
        'usais',
        'usamos',
        'usan',
        'usar',
        'usas',
        'uso',
        'va',
        'vais',
        'valor',
        'vamos',
        'van',
        'vaya',
        'verdad',
        'verdadera',
        'verdadero',
        'vosotras',
        'vosotros',
        'voy',
        'yo'
    ]
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/es.js
 ** module id = 2993
 ** module chunks = 0
 **/